import { Editor } from 'grapesjs';
import { RewardsListRenderer } from '@loyalty/editor-components';
import { faGifts } from '@fortawesome/pro-solid-svg-icons/faGifts';
import { EditorComponentDefinition } from '../types';
import { EditorContext } from '../../../services/editor-service';
import { RewardsListWidgetTraits } from './RewardsListWidgetTraits';
import { Toolbar, buildParticipantContextFromGrape } from '../../utils';
import { updateI18nAttributes } from '../i18n';

const CLASSNAME = 'qlfeditor-rewards__list';

export const rewardsListComponentDefinition: EditorComponentDefinition = {
  id: 'rewards-list',
  icon: faGifts,
  getLabel: ({ t }) => t('editor.component.rewards'),
  component: RewardsListGrapesComponent,
  traits: {
    form: RewardsListWidgetTraits,
  },
};

export function RewardsListGrapesComponent(editor: Editor) {
  const i18n = editor.I18n;
  const context: EditorContext = editor.Config.context;

  editor.DomComponents.addType(rewardsListComponentDefinition.id, {
    isComponent(el: HTMLElement) {
      return el.tagName === 'DIV' && el.classList.contains(CLASSNAME);
    },
    model: {
      defaults: {
        tagName: 'div',
        attributes: {
          scrollable: true,
          showRewardStock: true,
        },
        name: 'rewards-list',
        content: '',
        droppable: false,
        draggable: false,
        removable: false,
        copyable: false,
        traits: [],
      },
      initToolbar: Toolbar,
      init() {
        this.on('change:attributes:redeemButtonLabel', this.handleButtonLabelChange);
        this.on('change:attributes', () => setTimeout(() => this.view?.onRender()));
      },
      handleButtonLabelChange() {
        const { redeemButtonLabel } = this.getAttributes();
        updateI18nAttributes.call(this, i18n.getLocale(), { redeemButtonLabel });
      },
      toHTML(): string {
        return RewardsListRenderer(
          {
            state: context.widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
